import '../App.css';
import Seo from '../components/common/atoms/Seo';
import seoData from '../json/seo.json';
import textData from '../json/text.json';
import Header from '../components/menu/organisms/Header';
import Footer from  '../components/footer/Footer';
import TopicPath from '../components/common/atoms/TopicPath';
import H1 from '../components/common/atoms/H1';
import BackgroundAnimation from '../components/motion/atoms/BackgroundAnimation';
import WorksContent from '../components/works/organisms/WorksContent';

/**
 * 実績一覧ページ
 * @returns 
 */
function Works() {
  const links = [{link:'/works', pageName:textData['menu.works']['ja']}];
  const titleText = textData['works.title']['ja'];
  return (

    <div>
      <BackgroundAnimation />
      <Seo title={titleText} description={seoData.pages.works.description} path='/works' />

      <header>
        <Header />
      </header>
      
      <main className="main-content">
        <TopicPath links={links} />
        <H1 text={titleText}/>
        <WorksContent />
      </main>
      <footer>
        <Footer />
      </footer>

    </div>
  );
}

export default Works;
